import axios from "axios";

const API = axios.create({
  baseURL1: "https://kodo-backend.kodoscholarship.com/",
  baseURL: "https://kodo-backend.kodoscholarship.com/"
});

export default API;
